export default {"src":"/_next/static/media/legalDoc_64.bc34a884.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};